import type { AppRoute } from '@app/icare/shared/auth/ability'
import type { NavigateOptions } from '@tanstack/react-router'
import { TOUR_PATIENT_ID } from './config'
import type { TourId } from './types'

const withTourParams = (id: TourId) => (prev: Record<string, unknown>) => ({ ...prev, tour: id, tourStep: 0 })

export const routeForTour = (id: TourId): NavigateOptions => {
  switch (id) {
    case 'app-shell-intro':
    case 'home-intro':
    case 'home-outro':
      return { to: '/', search: withTourParams(id) } as NavigateOptions
    case 'orders-stock':
      return { to: '/orders-stock', search: withTourParams(id) } as NavigateOptions
    case 'orders-table':
      return { to: '/my-patients', search: withTourParams(id) } as NavigateOptions
    case 'patients-list':
      return { to: '/patienten', search: withTourParams(id) } as NavigateOptions
    case 'patient-edit':
    case 'patient-overview':
      return {
        to: '/patienten/$id',
        params: { id: TOUR_PATIENT_ID },
        search: withTourParams(id),
      } as NavigateOptions
    case 'patient-cost-carriers':
      return {
        to: '/patienten/$id/kostentraeger',
        params: { id: TOUR_PATIENT_ID },
        search: withTourParams(id),
      } as NavigateOptions
  }
}

export const subjectForTour = (id: TourId): AppRoute => routeForTour(id).to as AppRoute
